import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
export class UserCard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " User"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-3"></div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">First Name</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.firstName}
                        onChange={e => {
                          this.props.updateValue("firstName", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Surname</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.surname}
                        onChange={e => {
                          this.props.updateValue("surname", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Email</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.email}
                        onChange={e => {
                          this.props.updateValue("email", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  {/* <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Telephone</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.contactTelephone}
                        onChange={e => {
                          this.props.updateValue(
                            "contactTelephone",
                            e.target.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Address Line 1</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.addressLine1}
                        onChange={e => {
                          this.props.updateValue(
                            "addressLine1",
                            e.target.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Address Line 2</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.addressLine2}
                        onChange={e => {
                          this.props.updateValue(
                            "addressLine2",
                            e.target.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Postcode</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.postcode}
                        onChange={e => {
                          this.props.updateValue("postcode", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div> */}
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">PIN</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.pin}
                        onChange={e => {
                          this.props.updateValue("pin", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  {/* <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Role Type</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.roleType}
                        onChange={e => {
                          this.props.updateValue("roleType", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div> */}
                </div>
                <div className="ui-g-3"></div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/User/UI/UserCard.js